module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADUAAAAjCAYAAAA0aUL2AAAAAXNSR0IArs4c6QAAAIVJREFUWEftmTEOwCAQw8oPjv8/kie0UocunTL5Ss0cKcRmY1TVeWx2xtaj1lqf9zXnvDc8phzV1Kmmmop5XUtTmgIJ+PxA+FG1piJcYFhTIPyoWlMRLjCsKRB+VK2pCBcY1hQIP6rWVIQLDGsKhB9VayrCBYY1BcKPqv9hKkLSPLzlp9sF5kGGkVnhrh8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/page/crop/three-to-two.png
// module id = aTJg
// module chunks = 3